import React, { Component } from 'react';
import common from '../../common';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import config from './../../common/config';
import { makeClasses, getTrans, getUserProfile, pageViewTracking, customTracking } from './../../common/index';
import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';
import OutsideNotifier from './../OutsideNotifier';
import trackEventsObj from '../../common/new-pageTrackEvents'
import { LoginContext } from '../../Context';
import { Consume } from '../../Context/Consumer'

class LeagueShare extends Component {
  state = {
    copied: false,
    linkCopied: false,
    addClassLinkCopied: false,
    addClassCodeCopied: false,
  };

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  onCopy() {
    let pagename = "";
    if (window.location.pathname.indexOf("league-settings") > -1) {
      pagename = '/' + config.GAME_NAME + '/leagues/private/settings/'
    } else if (this.props.TotMembers > 1) {
      pagename = '/' + config.GAME_NAME + '/leagues/private/'
    } else {
      pagename = '/' + config.GAME_NAME + '/leagues/private/empty'
    }

    customTracking('Share - Copy Code', pagename)

    let codeCopiedStatus = getUserProfile(this.props.loginData).isLeagueCodeCopied;
    if (!codeCopiedStatus) {
      let { LeagueCode, LeagueId, LeagueName } = this.props;
      let leagueAchievementParams = {
        gamedayId: 0,
        name: LeagueName,
        code: LeagueCode,
        id: LeagueId,
        isCodeCopied: 1,
        isCodeShared: 0,
      };
      leagueAchievementParams.guid = getUserProfile(this.props.loginData).guid
      this.props.updateLeagueCodeLinkAchievement(leagueAchievementParams);
    }
    this.setState({ copied: true, addClassCodeCopied: true }, () => {


      setTimeout(() => {
        this.setState({ copied: false, addClassCodeCopied: false });
      }, 2000);
    });
  }

  onCopyLink() {
    let pagename = "";
    if (window.location.pathname.indexOf("league-settings") > -1) {
      pagename = '/' + config.GAME_NAME + '/leagues/private/settings/'
    } else if (this.props.TotMembers > 1) {
      pagename = '/' + config.GAME_NAME + '/leagues/private/'
    } else {
      pagename = '/' + config.GAME_NAME + '/leagues/private/empty'
    }

    customTracking('Share - Copy Link', pagename)
    let linkCopiedStatus = getUserProfile(this.props.loginData).isLeagueCodeShared;
    if (!linkCopiedStatus) {
      let { LeagueCode, LeagueId, LeagueName } = this.props;
      let leagueAchievementParams = {
        gamedayId: 0,
        name: LeagueName,
        code: LeagueCode,
        id: LeagueId,
        isCodeCopied: 0,
        isCodeShared: 1,
      };
      leagueAchievementParams.guid = getUserProfile(this.props.loginData).guid
      this.props.updateLeagueCodeLinkAchievement(leagueAchievementParams);
    }
    this.setState({ linkCopied: true, addClassLinkCopied: true }, () => {


      setTimeout(() => {
        this.setState({ linkCopied: false, addClassLinkCopied: false });
      }, 2000);
    });
  }

  render() {
    let {
      trans,
      LeagueCode,
      LeagueId,
      LeagueName,
      ShareLoad,
    } = this.props;

    if (this.props.showShare) {
      disableBodyScroll(document.querySelector('body'));
    } else {
      clearAllBodyScrollLocks();
    }

    const copyLinkClass = makeClasses({
      'si-selected': this.state.addClassLinkCopied,
    });
    const copyCodeClass = makeClasses({
      'si-selected': this.state.addClassCodeCopied,
    });
    let linkShareMsg = getTrans(
      trans,
      'shareLeagueLinkMsg',
      "Join my official UCL {game_name} league! Use the code: {league_code} or the link below. Let's see who's really the best! {league_link}"
    )
      .replace('{game_name}', config.gameName)
      .replace('{league_code}', LeagueCode)
      .replace('{league_link}', ShareLoad);
    return (
      <div className='si-modal si-active'>
        <OutsideNotifier className={"joinLeaguePopup"}
          handler={() => {
            this.props.toHide();
          }}
        >
          <div className='si-popup si-curved-sm si-active si-lg__popup'>
            <div className='si-bg--pattern' />
            <div className='si-popup__head'>
              {getTrans(
                this.props.trans,
                'inviteYourFrnds',
                'Invite your friends'
              )}
              <div className='si-close' onClick={() => this.props.toHide()} />
            </div>
            <div className='si-popup__body si-lg__invite si-ls'>
              <div className='si-social-share'>
                <div className='si-create-title'>
                  {getTrans(this.props.trans, 'leagueLink', 'League link')}
                </div>
                <div className='si-create-desc'>
                  {getTrans(
                    this.props.trans,
                    'inviteFriendsToLeague',
                    'Invite friends to your league whenever you want by sharing this link.'
                  )}
                </div>
                <CopyToClipboard
                  text={linkShareMsg}
                  onCopy={() => this.onCopyLink()}
                >
                  <div className={'si-ls__code ' + copyLinkClass}>
                    {this.state.addClassLinkCopied
                      ? getTrans(
                        this.props.trans,
                        'league_copy2clip',
                        'Copied to clipboard!'
                      )
                      : ShareLoad}
                    <i className='euro-copy' />
                    {this.state.addClassLinkCopied ? (
                      <div className='si-copy'>
                        <i className='euro-check'></i>
                      </div>
                    ) : null}
                  </div>
                </CopyToClipboard>
                <div className='si-share-med'>
                  <div className='si-share-left'>
                    <div
                      className='si-share-item si-fb-share'
                      onClick={(e) => {
                        customTracking(
                          'Share - Facebook',
                          '/' + config.GAME_NAME + '/leagues/private/empty/'
                        );

                      }}
                    >
                      <i className='euro-facebook' />
                    </div>
                    <div
                      className='si-share-item si-tweet-share'
                      onClick={(e) => {
                        customTracking(
                          'Share - Twitter  ',
                          '/' + config.GAME_NAME + '/leagues/private/empty/'
                        );
                      }}
                    >
                      <i className='euro-twitter' />
                    </div>
                  </div>
                  <CopyToClipboard
                    text={linkShareMsg}
                    onCopy={() => this.onCopyLink()}
                  >
                    <div className='si-btn si-btn--primary'>
                      {/* <i className='euro-share' /> */}
                      <span>
                        {getTrans(this.props.trans, 'copyLink', 'Copy link')}
                      </span>
                    </div>
                  </CopyToClipboard>
                </div>
              </div>
              <div className='si-join-code'>
                <div className='si-create-title'>
                  {getTrans(this.props.trans, 'leagueCode', 'League code')}
                </div>
                <div className='si-create-desc'>
                  {getTrans(
                    this.props.trans,
                    'yourFrndsCanAlsoJoin',
                    'Your friends can also join by entering this code.'
                  )}
                </div>
                <CopyToClipboard text={LeagueCode} onCopy={() => this.onCopy()}>
                  <div className={'si-code-wrp ' + copyCodeClass}>
                    <div className={this.state.addClassCodeCopied ? 'si-code-wrp-box si-copy-clip' : 'si-code-wrp-box'} >
                      <span>
                        {this.state.addClassCodeCopied
                          ? getTrans(
                            this.props.trans,
                            'league_copy2clip',
                            'Copied to clipboard!'
                          )
                          : LeagueCode}
                      </span>
                      <i className='euro-copy' />
                      {this.state.addClassCodeCopied ? (
                        <div className='si-copy'>
                          <i className='euro-check'></i>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </CopyToClipboard>
              </div>
            </div>
          </div>
        </OutsideNotifier>
      </div>
    );
  }
}

export default Consume(LeagueShare, [LoginContext]);
